import type { SetupProgress } from "features/types/setupProgress";
import { usePitcher } from "features/utils/usePitcher";
import { useEffect, useState } from "react";

export const useSetupProgress = (): SetupProgress => {
  const pitcher = usePitcher();

  const [setupProgress, setSetupProgress] = useState(
    pitcher.clients.setup.getProgress(),
  );

  useEffect(() => {
    const disposable = pitcher.clients.setup.onSetupProgressUpdate((progress) =>
      setSetupProgress(progress),
    );

    return () => disposable.dispose();
  }, []);

  return setupProgress;
};
